import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Dashboard.css';
import { useAuth } from '../contexts/AuthContext';
import Loading from './Loading';

const Dashboard = () => {
  const { userData, currentUser, logout } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time if needed
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (err) {
      alert('Failed to log out');
    }
  };

  if (loading) {
    return <Loading />;
  }

  const role = userData?.role;
  const canManageProjects =
    role === 'project_manager' || role === 'admin' || role === 'director';
  const canApproveUsers = currentUser?.email === 'dan@flair.ac';

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <img
          src="/flair-ac-small.svg"
          alt="Flair AC Logo"
          className="dashboard-logo"
        />
        <h1 className="dashboard-title">
          Welcome to Flair Portal
        </h1>
        <p className="dashboard-subtitle">
          Manage your projects and tasks efficiently
        </p>
        <button
          onClick={handleLogout}
          className="dashboard-logout-button"
        >
          Logout
        </button>
      </div>
      
      <div className="dashboard-content">
        <div className="dashboard-actions">
          <DashboardBox 
            to="/timesheet" 
            icon="⏰" 
            label="Timesheet"
            description="Track your working hours"
          />
          <DashboardBox 
            to="/todo" 
            icon="✅" 
            label="Quick Tasks"
            description="Manage your daily tasks"
          />
          <DashboardBox 
            to="/commissioning" 
            icon="🔧" 
            label="Commissioning"
            description="Manage commissioning records"
          />

          {canManageProjects && (
            <>
              <DashboardBox 
                to="/projects" 
                icon="📁" 
                label="Cost Tracking"
                description="View and manage project costs"
              />
              <DashboardBox 
                to="/subcontractors" 
                icon="👷‍♂️" 
                label="Subcontractors"
                description="Manage subcontractors"
              />
              <DashboardBox 
                to="/cis" 
                icon="💷" 
                label="CIS Tracker"
                description="Track CIS deducted and suffered"
              />
            </>
          )}

          {canApproveUsers && (
            <DashboardBox 
              to="/admin-approval" 
              icon="🔑" 
              label="Admin Approval"
              description="Manage user approvals"
            />
          )}
        </div>
      </div>
    </div>
  );
};

function DashboardBox({ to, icon, label, description }) {
  return (
    <Link 
      to={to} 
      className="dashboard-box"
    >
      <div className="dashboard-box-content">
        <div className="dashboard-box-icon">{icon}</div>
        <h3 className="dashboard-box-label">{label}</h3>
        <p className="dashboard-box-description">{description}</p>
      </div>
      </Link>
  );
}

export default Dashboard; 